import { css } from '@mui/material/styles';
export const iconButtonComponentOverrides = {
    MuiIconButton: {
        defaultProps: {
            size: 'medium',
            disableRipple: true,
            disableTouchRipple: true
        },
        styleOverrides: {
            root: ({ theme }) => css `
                transition: unset;
                border-radius: ${theme.tokens.FuelBorderRadiusMd};
                border: 1px solid transparent;
                display: inline-flex;
                align-items: center;

                &[data-fuel-outlined=true] {
                    box-shadow: ${theme.tokens.FuelShadowXs}, rgba(0, 0, 0, 0.05) 0px 1px 0px 0px;
                    border: 1px solid ${theme.tokens.FuelColorBorderDark};
                }

                &:hover {
                    color: ${theme.tokens.FuelColorTextPrimary};
                    background-color: rgba(0, 0, 0, 0.04);
                }

                &:active {
                    background-color: ${theme.tokens.FuelColorBackgroundActionSecondaryPressed};
                }

                &:focus {
                    outline: none;
                }

                &.Mui-focusVisible {
                    box-shadow: ${theme.tokens.FuelShadowFocused};
                }
            `,
            sizeSmall: ({ theme }) => css `
                height: ${theme.tokens.FuelSpacing8};
                width: ${theme.tokens.FuelSpacing8};
                padding: 0.1875rem;
            `,
            sizeMedium: () => css `
                height: 2.25rem;
                width: 2.25rem;
                padding: 0.3125rem;
            `,
            sizeLarge: ({ theme }) => css `
                height: ${theme.tokens.FuelSpacing10};
                width: ${theme.tokens.FuelSpacing10};
                padding: 0.4375rem;
            `,
            disabled: ({ theme }) => css `
                color: ${theme.tokens.FuelColorTextActionSecondary};
                background-color: transparent;
                opacity: 0.5;
                cursor: not-allowed;
                box-shadow: none;

                &[data-fuel-outlined='true'] {
                    border-color: ${theme.tokens.FuelColorBorderLight};
                    box-shadow: none;
                }
            `
        }
    }
};
